var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMusicOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 48,
  width: 48
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.55 42.35q-3.25 0-5.475-2.25-2.225-2.25-2.225-5.45 0-3.25 2.225-5.475Q16.3 26.95 19.55 26.95q1.35 0 2.425.35 1.075.35 1.875 1V5.65h12.3v7.15h-8.9v21.85q0 3.2-2.225 5.45t-5.475 2.25Z"
})));

export default SvgMusicOn;